// @ts-strict-ignore
import { TEMPLATE, UapParams, type AdSlot } from '@wikia/ad-engine';
import { Inject, Injectable } from '@wikia/dependency-injection';

@Injectable({ autobind: false })
export class UapDomReader {
	constructor(
		@Inject(TEMPLATE.PARAMS) private params: UapParams,
		@Inject(TEMPLATE.SLOT) private adSlot: AdSlot,
	) {}

	getNavbarOffsetResolvedToNone(): number {
		const distance = this.getNavbarOffsetResolved() - window.scrollY;

		return distance <= 0 ? 0 : distance;
	}

	getNavbarOffsetResolved(): number {
		return this.getSlotHeightResolved();
	}

	getSlotOffsetResolvedToNone(): number {
		// This is a patch for a transition to the new top navigation
		// It prevents TLB from slipping under the top navbar after tlb ad refresh
		// TODO clean this up after the transition
		const topNavElement = document.getElementById('global-top-navigation');
		const topNavHeight = topNavElement?.clientHeight ?? 0;

		return this.getNavbarOffsetResolvedToNone() - this.getSlotHeightResolved() + topNavHeight;
	}

	getSlotHeightImpactToResolved(): number {
		const minHeight = this.getSlotHeightResolved();
		const maxHeight = this.getSlotHeightImpact();
		const progress = this.getProgressImpactToResolved();

		return maxHeight - (maxHeight - minHeight) * progress;
	}

	/**
	 * Progress changes between 0 (impact, full height) to 1 (resolved size);
	 */
	getProgressImpactToResolved(): number {
		const mixHeight = this.getSlotHeightResolved();
		const maxHeight = this.getSlotHeightImpact();
		const progress = window.scrollY / (maxHeight - mixHeight);

		return progress >= 1 ? 1 : progress;
	}

	getSlotHeightImpact(): number {
		if (this.params?.config?.aspectRatio?.default === undefined) {
			return this.adSlot.getElement().offsetHeight;
		}

		return this.calculateSlotHeight(this.params.config.aspectRatio.default);
	}

	getSlotHeightResolved(): number {
		if (this.params?.config?.aspectRatio?.resolved === undefined) {
			return this.adSlot.getElement().offsetHeight;
		}

		return this.calculateSlotHeight(this.params.config.aspectRatio.resolved);
	}

	private calculateSlotHeight(ratio: number): number {
		return (1 / ratio) * this.adSlot.getElement().offsetWidth;
	}

	getSlotHeightClipping(): string {
		const scroll = window.scrollY;

		if (!scroll || scroll <= 0) {
			return 'unset';
		}

		if (scroll >= this.adSlot.getElement().offsetHeight) {
			return 'rect(0, 0, 0, 0)';
		}

		return `rect(0 ${this.adSlot.getElement().offsetWidth}px ${
			this.adSlot.getElement().offsetHeight - scroll
		}px 0)`;
	}
}
